import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";

const rootElement = document.querySelector("#root")

ReactDOM.render(<App/>, rootElement);